import { createContext, useContext, useMemo } from 'react';
import { EVENT_NAMES, UsageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackingContext = /*#__PURE__*/createContext({
  appName: '',
  screenName: '',
  trackUserInteraction: () => {},
  trackPageView: () => {},
  trackModalOpen: () => {},
  trackModalClose: () => {}
});
const TrackingContextProvider = ({
  children,
  appName,
  screenName,
  usageTracker
}) => {
  const contextValue = useMemo(() => {
    if (usageTracker) {
      UsageTracker.clone(usageTracker);
    }
    return {
      trackUserInteraction: (action, properties = {}) => UsageTracker.track(EVENT_NAMES.UserInteraction, Object.assign({
        app: appName,
        screen: screenName,
        action
      }, properties)),
      trackPageView: screen => UsageTracker.track(EVENT_NAMES.pageView, {
        app: appName,
        screen,
        value: screenName
      }),
      trackModalOpen: modalName => UsageTracker.track(EVENT_NAMES.UserInteraction, {
        app: appName,
        action: 'open modal',
        screen: screenName,
        value: modalName
      }),
      trackModalClose: modalName => UsageTracker.track(EVENT_NAMES.UserInteraction, {
        app: appName,
        action: 'close modal',
        screen: screenName,
        value: modalName
      })
    };
  }, [appName, screenName, usageTracker]);
  return /*#__PURE__*/_jsx(TrackingContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useTrackingContext = () => {
  return useContext(TrackingContext);
};
export default TrackingContextProvider;